import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Barcode from "react-jsbarcode";
import ReactToPrint from "react-to-print";
import { createBarcodePrintList } from "../../../actions/BarcodePrintListAction";
import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  Select,
  Divider,
  AutoComplete,
  Form,
  Button,
  Drawer,
  Table,
} from "antd";

const BatchBarcodelistView = ({ barcodelist, reload, count, createBarcodePrintList }) => {
  const columns = [
    { title: '#', dataIndex: 'serialNumber', key: 'serialNumber' },
    { title: 'Product', dataIndex: 'product', key: 'product' },
    { title: 'Variation', dataIndex: 'variation', key: 'variation' },
    { title: 'Barcode', dataIndex: 'barcode', key: 'barcode' },
    { title: 'Qty', dataIndex: 'quantity', key: 'quantity' },
  ];

  console.log("barcode", barcodelist)
  const dataSource = barcodelist.current.map((barcode, index) => ({
    key: barcode.variation.barcode,
    serialNumber: index + 1,
    product: barcode.variation.product_code,
    variation: barcode.variation.Attribute_details,
    barcode: barcode.variation.barcode,
    category: barcode.variation.category,
    brand_name: barcode.variation.ProductDetails.brand_name,
    quantity: barcode.variation.quantity
  }));
  
  const handleprinttable = (data) => {
    console.log(data);
    const formdata = new FormData();
    formdata.append("data", JSON.stringify(data));
    console.log(formdata);
    createBarcodePrintList(formdata);
  }

  const componentRef = useRef();
  const individualRefs = useRef({});
  
  useEffect(() => {
    count.current = 0;
  }, [reload]);

  const barcodeLabel = (obj, index) => {
    console.log("obj in barcode label", obj.variation); 
    return (
      <div
        className="barcode-label"
        style={{
          width: "1.5in",
          height: "1in",
          padding: "2px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          pageBreakAfter: "always",
          border: "1px solid #e0e0e0",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        <div style={{ 
          fontSize: "8px", 
          fontWeight: "700", 
          textAlign: "center",
          lineHeight: "1",
          marginBottom: "2px",
          marginTop: "10px",
        }}>
          STATION
        </div>
        
        <div style={{ 
          fontSize: "8px", 
          fontWeight: "500", 
          textAlign: "center",
          lineHeight: "1.1",
          marginBottom: "1px",
          overflow: "hidden"
        }}>
          {obj.variation.category} {obj.variation.title}          
        </div>
        
        <div style={{ 
          fontSize: "8px", 
          fontWeight: "500", 
          textAlign: "center",
          marginBottom: "1px",
          overflow: "hidden"
        }}>
          ({obj.variation.ProductDetails.brand_name}) | {obj.variation.Attribute_details}
        </div>
        
        <div style={{ marginBottom: "0px" }}>
          <Barcode 
            options={{ 
              height: 20,
              width: 1.3,
              fontSize: 8,
              margin: 0,
              displayValue: true
            }} 
            value={obj.variation.barcode} 
          />
        </div>

        <div style={{ 
          fontSize: "8px", 
          fontWeight: "500", 
          textAlign: "center",
          marginBottom: "1px",
        }}>
          {obj.variation.batch_no}
        </div>
      </div>
    );
  };

  // Modified to return barcode labels based on quantity
  const barcodesForPrint = (obj) => {
    const quantity = parseInt(obj.variation.quantity) || 1;
    const labels = [];
    for (let i = 0; i < quantity; i++) {
      labels.push(
        <React.Fragment key={i}>
          {barcodeLabel(obj, i)}
        </React.Fragment>
      );
    }
    return labels;
  };

  // Single barcode for display
  const barcodeForDisplay = (obj) => {
    return barcodeLabel(obj, 0);
  };

  return (
    <>
      <style>
        {`
          @media print {
            @page {
              size: 1.5in 1in;
              margin: 0;
            }
            
            body {
              margin: 0;
              padding: 0;
            }
            
            .barcode-label {
              page-break-after: always;
              border: none !important;
            }
            
            .no-print {
              display: none !important;
            }
            
            .print-container {
              margin: 0;
              padding: 0;
            }
          }
          
          @media screen {
            .barcode-wrapper {
              display: inline-block;
              margin: 10px;
              vertical-align: top;
            }
            
            .barcode-item {
              text-align: center;
            }
            
            .barcode-item .barcode-label {
              margin-bottom: 8px;
            }
            
            .print-only {
              position: absolute;
              left: -9999px;
              top: -9999px;
            }
          }
        `}
      </style>

      <Row>
        <Col span={16}>
          {/* Horizontal display of barcodes - showing only 1 for preview */}
          <div style={{ marginBottom: "30px" }}>
            {barcodelist.current.map((barcode, barcodeIdx) => {
              const uniqueKey = `barcode-${barcodeIdx}`;
              return (
                <div key={uniqueKey} className="barcode-wrapper no-print">
                  <div className="barcode-item">
                    {/* Display container - shows only one label */}
                    <div>
                      {barcodeForDisplay(barcode)}
                    </div>
                    
                    <ReactToPrint
                      trigger={() => (
                        <Button 
                          type="default" 
                          size="small"
                          style={{ marginTop: "5px" }}
                        >
                          Print ({barcode.variation.quantity})
                        </Button>
                      )}
                      content={() => individualRefs.current[uniqueKey]}
                      pageStyle={`
                        @page {
                          size: 1.5in 1in;
                          margin: 0;
                        }
                      `}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          
          {/* Hidden print containers - positioned off-screen but still rendered */}
          {barcodelist.current.map((barcode, barcodeIdx) => {
            const uniqueKey = `barcode-${barcodeIdx}`;
            return (
              <div 
                key={`print-${uniqueKey}`}
                ref={el => {
                  if (el) {
                    individualRefs.current[uniqueKey] = el;
                  }
                }}
                className="print-only"
              >
                {barcodesForPrint(barcode)}
              </div>
            );
          })}
        </Col>
        <Col span={8} className="no-print">
          <Button 
            type="primary" 
            style={{ float: "right", marginBottom: "10px" }} 
            onClick={() => handleprinttable(dataSource)}
          >
            Save
          </Button>
          <Table 
            columns={columns} 
            dataSource={dataSource} 
            pagination={false} 
          />
        </Col>
      </Row>
    </>
  );
};

export default connect(null, { createBarcodePrintList })(BatchBarcodelistView);